import React from 'react';
import PlatformsSection from '../PlatformsSection';

const PlatformsPage = () => {
  return (
    <div className="py-10">
      <PlatformsSection />
    </div>
  );
};

export default PlatformsPage;